import React, { useEffect } from 'react';

export default function AnimatedGradientBackground({ style = {} }) {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.getElementById('animated-gradient-styles')) return;

    const css = `
      @keyframes moveGradient {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }

      /* limited hue rotation to keep colors in blues/purples */
      @keyframes hueShift {
        0% { filter: hue-rotate(-20deg); }
        50% { filter: hue-rotate(20deg); }
        100% { filter: hue-rotate(-20deg); }
      }

      .animated-gradient-back {
        position: fixed;
        inset: 0;
        z-index: -1;
        pointer-events: none;
        background: linear-gradient(135deg, #2b6cff 0%, #6da2ff 30%, #9b6bff 60%, #c17bff 100%);
        background-size: 200% 200%;
        will-change: background-position, filter;
  /* slower movement and much slower color shift for a calm effect */
  animation: moveGradient 16s ease-in-out infinite, hueShift 90s ease-in-out infinite;
      }
    `;

    const styleEl = document.createElement('style');
    styleEl.id = 'animated-gradient-styles';
    styleEl.appendChild(document.createTextNode(css));
    document.head.appendChild(styleEl);

    return () => {
      try {
        const el = document.getElementById('animated-gradient-styles');
        if (el) el.remove();
      } catch (e) {}
    };
  }, []);

  return <div className="animated-gradient-back" style={style} />;
}
